"use client"

import { useState } from "react"

interface AssessmentTabsProps {
  onTabChange?: (tab: string) => void
}

export function AssessmentTabs({ onTabChange }: AssessmentTabsProps) {
  const [activeTab, setActiveTab] = useState("assessments")

  const handleTabClick = (tab: string) => {
    setActiveTab(tab)
    onTabChange?.(tab)
  }

  return (
    <div className="mt-6 border-b border-gray-200">
      <div className="flex gap-8">
        <button
          onClick={() => handleTabClick("assessments")}
          className={`pb-3 border-b-4 ${
            activeTab === "assessments"
              ? "border-gray-200 text-gray-900 font-bold"
              : "border-transparent text-gray-500 hover:text-gray-900 font-medium"
          } text-sm px-2 transition-colors`}
        >
          Assessments
        </button>
        <button
          onClick={() => handleTabClick("submissions")}
          className={`pb-3 border-b-4 ${
            activeTab === "submissions"
              ? "border-gray-200 text-gray-900 font-bold"
              : "border-transparent text-gray-500 hover:text-gray-900 font-medium"
          } text-sm px-2 transition-colors`}
        >
          Submissions
        </button>
        <button
          onClick={() => handleTabClick("analytics")}
          className={`pb-3 border-b-4 ${
            activeTab === "analytics"
              ? "border-gray-200 text-gray-900 font-bold"
              : "border-transparent text-gray-500 hover:text-gray-900 font-medium"
          } text-sm px-2 transition-colors`}
        >
          Analytics
        </button>
      </div>
    </div>
  )
}
